// extracted by mini-css-extract-plugin
module.exports = {"list":"Specifications_list__3Ialj","item":"Specifications_item__1ZgrQ","icon":"Specifications_icon__2Rr6a","skeleton":"Specifications_skeleton__1IIVl"};